import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    if (payload?.id) {
      return buildApiUrl(`${ADMIN_ENDPOINTS.ADMIN_ROLE_UPDATE.replace(':roleId', payload.id)}`, {
        queryParams: { service: 'rapidoo-admin' }
      })
    }
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_ROLE_ADD, {
      queryParams: { service: 'rapidoo-admin' }
    })
  },

  method(payload) {
    return 'POST'
  },

  format(payload) {
    return {
      name: payload.name,
      service: 'rapidoo-admin',
      permissions: payload.permissions || [],
    }
  },

  parse(raw = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || "Erreur lors de l'enregistrement du rôle",
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Rôle enregistré avec succès',
      data: raw.data,
    }
  },
}
